<template>
  <div class="wrapper">
    <c-select
      v-model="localValue"
      type="select"
      :required-mark="field.required"
      :floating-label="field.name"
      :searchable="searchable"
      :items="options"
      :clearable="clearable"
      :custom-options="field.custom"
      :invalid="!!error"
      :error="error"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CSelect from "@/components/controls2/Select";
import { formatList } from "../utils";

export default {
  components: { CSelect },
  props: ["field", "value", "editable", "error"],
  data() {
    return {
      inited: false,
      localValue: null,
    };
  },

  computed: {
    ...mapGetters({
      dictionaries: "profile/getDictionaries",
    }),
    searchable() {
      return true;
    },

    clearable() {
      return true;
    },
    variants() {
      const code = this.field.dictionaryCode || this.field.parentId;
      return this.dictionaries[code] || [];
    },
    options() {
      return formatList(this.variants);
    },
  },

  watch: {
    localValue(v) {
      if (!v) {
        this.$emit("input", {
          items: [],
        });
      } else if (v.custom) {
        this.$emit("input", {
          customItems: [v.label],
        });
      } else {
        this.$emit("input", {
          items: [v.value],
        });
      }
      
      if (this.inited) this.$emit("change");
    },
    value(v) {
      
      this.setData(v);
    },
  },

  async created() {
    
    await this.$store.dispatch("profile/getDictionary", {
      code: this.field.dictionaryCode,
      fieldId: this.field.parentId,
    });
    if (this.value) this.setData(this.value);

  },

  methods: {
    setData(value) {
      if (!value) return;
      this.inited = false;

      const { items, customItems } = value;

      let newValue = null;

      if (items && items.length) {
        const [item] = items;
        newValue = {
          value: `${item}`,
        };
      } else if (customItems && customItems.length) {
        const [item] = customItems;
        newValue = {
          value: `${item}`,
          label: `${item}`,
          custom: true,
        };
      }

      if ((newValue && newValue.value) !== (this.localValue && this.localValue.value)) {
        this.localValue = newValue;
      }
      this.$nextTick(() => {
        this.inited = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  // padding-top: 6px;
}
/deep/ {
  .c-input-container-list-item {
    &-label {
      white-space: normal;
      padding: 3px 0;
      line-height: 1.2;
    }
  }
  .c-input-value_type_select {
    &_clearable {
      max-width: calc(100% - 45px) !important;
    }
  }
}
</style>
